import { createContext } from "react";

export interface AudioContext {
    isMuted: boolean;
    setIsMuted: (muted: boolean) => void;
}

const context = createContext<AudioContext>({} as AudioContext);
context.displayName = "Audio";

export const AudioContext = context;
